/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ApexCharts from "apexcharts";
import {
  Button, Grid, Form, Divider, Checkbox,
  Dropdown, Segment, Dimmer, Loader
} from "semantic-ui-react";
import MonitoringReport from "components/login-config/configuration/report/MonitoringReport";
import AnalyzerDNReport from "components/login-config/configuration/report/AnalyzerDNReport";
import FullReport from "components/login-config/configuration/report/FullReport";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

const dropdownOptions = [
  {
    key: Constants.CONFORM,
    value: Constants.CONFORM,
    text: Strings.CONFORM_STRING
  },
  {
    key: Constants.CONFORM_W_RESTRICTION,
    value: Constants.CONFORM_W_RESTRICTION,
    text: Strings.CONFORM_W_RESTRICTION_STRING
  },
  {
    key: Constants.NON_CONFORM,
    value: Constants.NON_CONFORM,
    text: Strings.NON_CONFORM_STRING
  }
];

let dpBarGraphOptions = {
  tooltip: {
    enabled: true,
    x: {
      show: true,
      formatter: (val) => {
        return Strings.ADDRESS + ": " + val;
      },
    },
  },
  chart: {
    id: Constants.AMPLITUDE_ID,
    type: "bar",
    locales: [{
      "name": "pt-br",
      "options": {
        "toolbar": {
          "exportToSVG": "Baixar SVG",
          "exportToPNG": "Baixar PNG",
          "exportToCSV": "Baixar CSV",
          "menu": "Baixar"
        }
      }
    }],
    defaultLocale: "pt-br",
  },
  title: {
    text: Strings.AMPLITUDE,
    align: "center"
  },
  xaxis: {
    type: "category",
    title: {
      text: Strings.ADDRESS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: Constants.LABELS_FONT_SIZE
      }
    }
  },
  yaxis: {
    min: 0,
    max: 6,
    tickAmount: 6,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
      },
      style: {
        fontSize: Constants.LABELS_FONT_SIZE
      }
    },
    title: {
      text: Strings.VOLTAGE_V_PEAK_TO_PEAK
    },
  },
  series: [{
    name: Strings.AMPLITUDE,
    data: [],
  }],
  colors: [function ({ value }) {
    return (UtilsInstance.getBarGraphColorBasedOnValue(value, Constants));
  }],
  plotOptions: {
    bar: {
      dataLabels: {
        position: "top",
      }
    }
  },
  dataLabels: {
    formatter: function (val) {
      if (val < 0) {
        // Don't show the number above a bar with
        // negative values
        return "";
      }
      else if (val === 0) {
        return "0,00";
      }
      else {
        return val;
      }
    },
    style: {
      fontSize: "16px",
      fontFamily: "Helvetica, Arial, sans-serif",
      fontWeight: 400,
      colors: ["#212121"],
    },
    offsetY: -25,
  },
};

let dnWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    id: Constants.CHART_ID,
    type: "line",
  },
  colors: [Constants.BLUE_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center",
    style: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif"
    }
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_NS
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        cssClass: "apexcharts-xaxis-label",
      }
    }
  },
  yaxis: {
    min: -1,
    max: 4,
    tickAmount: 8,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(2) + " V";
      },
      style: {
        colors: [],
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: 400,
        cssClass: "apexcharts-yaxis-label",
      }
    },
    title: {
      text: Strings.VOLTAGE_V
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

class Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isGenerateReportDimmerActive: false,

      savedClients: [],
      savedExecutors: [],

      isMonChecked: false,
      isDPChecked: false,

      // User input data
      clientProjectName: "",
      clientNetworkName: "",
      clientLocation: "",
      clientCompanyName: "",
      clientAccountableName: "",
      clientAddress: "",
      clientCity: "",
      clientTel: "",
      executingCompanyName: "",
      executingAccountableName: "",
      executingTel: "",
      executingEmail: "",
      notes: "",
      conformity: "",
      // The report
      report: "",
      reportFilename: "",
      // Report loading
      startSaveTime: "",
      loaderText1: Strings.GENERATING_REPORT_WAITING,
      loaderText2: ""
    };
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_REPORT_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Data retrieval functions ----------------
  retrieveMonitoringData = async (userInput) => {
    this.setGeneratingDimmerState(true);

    let livelist = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS, { mode: "cors" })
      .then(res => res.json())
      .then(data => data.sort(UtilsInstance.sortBy("address", false, parseInt)));

    let log = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "log/protocol", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let uptime = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.uptime);

    let statistics = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "statistics", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let configData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "config", { mode: "cors" })
      .then(res => res.json())
      .then(data => data);

    let wifiStatus = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.status);

    let wifiConfigData = "";

    if (wifiStatus === Constants.CONNECTED_STATUS) {
      wifiConfigData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);
    }
    else {
      wifiConfigData = {
        "wifiMode": "",
        "hiddenSSID": false,
        "wifiName": "",
        "wifiAddr": "",
        "wifiNetmask": "",
        "wifiGateway": "",
        "wifiDNS": "",
        "wifiPwd": ""
      };
    }

    let tag = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
      .then(res => res.json())
      .then(data => data.tag);

    let ip = window.location.hostname;

    this.setState({
      reportFilename: `Relatório - TS Monitor DeviceNet - Protocolo (${ip}).pdf`,
      report: <MonitoringReport
        userInput={userInput}
        livelist={livelist}
        log={log}
        uptime={uptime}
        statistics={statistics}
        configData={configData}
        tag={tag}
        wifiConfigData={wifiConfigData}
        conformity={this.state.conformity}
      />
    });
  }

  retrieveAnalyzerDPData = async (userInput) => {
    this.setGeneratingDimmerState(true);

    let allTimesOk = false;
    let oscilloscopeData = [];
    let showMoreThanOneMinuteWaiting = true;
    let showMoreThanTwoMinutesWaiting = true;

    const startCounterTime = Date.now();

    while (allTimesOk === false) {
      oscilloscopeData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "oscilloscopeWaveAll1byte", { mode: "cors" })
        .then(res => res.json())
        .then(data => UtilsInstance.excludeEmptyWaves(data).sort(UtilsInstance.sortBy("address", false, parseInt)));

      let timeNow = Date.now();
      let elapsedTimeSinceGenerateReportClick = timeNow - this.state.startSaveTime;
      let hasOldEvent = false;

      console.log("Tempo desde que clicou no botão: ", elapsedTimeSinceGenerateReportClick);

      for (let i = 0; i < oscilloscopeData.length; i++) {
        let waveTime = oscilloscopeData[i].time * 1000;
        console.log("Tempo da forma de onda: ", waveTime);
        if (waveTime > elapsedTimeSinceGenerateReportClick) {
          console.log("Tempo da forma de onda muito antigo");
          hasOldEvent = true;
          break;
        }
      }

      const currentTime = Date.now();
      console.log("\nTempo decorrido: ", ((currentTime - startCounterTime) / 1000), " segundos\n");

      if ((currentTime - startCounterTime >= 60000) && (currentTime - startCounterTime < 120000) && showMoreThanOneMinuteWaiting) {
        showMoreThanOneMinuteWaiting = false;
        this.setState({
          loaderText1: Strings.GENERATING_REPORT_WAITING,
          loaderText2: Strings.GENERATING_REPORT_WAITING_1
        }, () => {
          console.log("Primeiro minuto");
        });
      }
      else if ((currentTime - startCounterTime >= 120000) && showMoreThanTwoMinutesWaiting) {
        showMoreThanTwoMinutesWaiting = false;
        this.setState({
          loaderText1: Strings.GENERATING_REPORT_WAITING,
          loaderText2: Strings.GENERATING_REPORT_WAITING_2
        }, () => {
          console.log("Segundo minuto");
        });
      }

      if (!hasOldEvent || (currentTime - startCounterTime >= 180000)) {
        allTimesOk = true;
      }
    }
    // Se todas as formas de onda forem recentes, ou se houver passado 3 minutos, vamos para
    // a próxima parte da geração do relatório
    if (allTimesOk) {

      let liveList = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "liveList/fisic", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.sort(UtilsInstance.sortBy("address", false, function (a) { return a; })));

      let livelistMap = this.createLivelistMap(liveList);

      let networkData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "networkData", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let uptime = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.uptime);

      let tag = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag);

      let imgURIs = await this.getOscilloscopeImgURIs(oscilloscopeData, livelistMap);

      let ampImgURIs = await this.getDPBarGraphImgURIsAmp(liveList);
      let minAmpImgURIs = await this.getDPBarGraphImgURIsMinAmp(liveList);

      let logData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "log/fisic", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.getNewest200Events(data));

      let configData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let wifiStatus = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.status);

      let wifiConfigData = "";

      if (wifiStatus === Constants.CONNECTED_STATUS) {
        wifiConfigData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
          .then(res => res.json())
          .then(data => data);
      }
      else {
        wifiConfigData = {
          "wifiMode": "",
          "hiddenSSID": false,
          "wifiName": "",
          "wifiAddr": "",
          "wifiNetmask": "",
          "wifiGateway": "",
          "wifiDNS": "",
          "wifiPwd": ""
        };
      }

      let ip = window.location.hostname;

      this.setState({
        reportFilename: `Relatório - TS Monitor DeviceNet - Meio Físico (${ip}).pdf`,
        report: <AnalyzerDNReport
          userInput={userInput}
          livelist={liveList}
          livelistMap={livelistMap}
          baudRate={networkData.baudrate}
          masters={networkData.nMasters}
          slaves={networkData.nSlaves}
          tensaoIdle={networkData.tensaoIdle}
          tag={tag}
          uptime={uptime}
          imgURIs={imgURIs}
          ampImgURIs={ampImgURIs}
          minAmpImgURIs={minAmpImgURIs}
          log={logData}
          configData={configData}
          wifiConfigData={wifiConfigData}
          conformity={this.state.conformity}
        />
      });
    }
  }

  retrieveAnalyzerDPAndMonitoringData = async (userInput) => {
    this.setGeneratingDimmerState(true);

    let allTimesOk = false;
    let oscilloscopeData = [];
    let showMoreThanOneMinuteWaiting = true;
    let showMoreThanTwoMinutesWaiting = true;

    const startCounterTime = Date.now();

    while (allTimesOk === false) {
      oscilloscopeData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "oscilloscopeWaveAll1byte", { mode: "cors" })
        .then(res => res.json())
        .then(data => UtilsInstance.excludeEmptyWaves(data).sort(UtilsInstance.sortBy("address", false, parseInt)));

      let timeNow = Date.now();
      let elapsedTimeSinceGenerateReportClick = timeNow - this.state.startSaveTime;
      let hasOldEvent = false;

      console.log("Tempo desde que clicou no botão: ", elapsedTimeSinceGenerateReportClick);

      for (let i = 0; i < oscilloscopeData.length; i++) {
        let waveTime = oscilloscopeData[i].time * 1000;
        console.log("Tempo da forma de onda: ", waveTime);
        if (waveTime > elapsedTimeSinceGenerateReportClick) {
          console.log("Tempo da forma de onda muito antigo");
          hasOldEvent = true;
          break;
        }
      }

      const currentTime = Date.now();
      console.log("\nTempo decorrido: ", ((currentTime - startCounterTime) / 1000), " segundos\n");

      if ((currentTime - startCounterTime >= 60000) && (currentTime - startCounterTime < 120000) && showMoreThanOneMinuteWaiting) {
        showMoreThanOneMinuteWaiting = false;
        this.setState({
          loaderText1: Strings.GENERATING_REPORT_WAITING,
          loaderText2: Strings.GENERATING_REPORT_WAITING_1
        }, () => {
          console.log("Primeiro minuto");
        });
      }
      else if ((currentTime - startCounterTime >= 120000) && showMoreThanTwoMinutesWaiting) {
        showMoreThanTwoMinutesWaiting = false;
        this.setState({
          loaderText1: Strings.GENERATING_REPORT_WAITING,
          loaderText2: Strings.GENERATING_REPORT_WAITING_2
        }, () => {
          console.log("Segundo minuto");
        });
      }

      if (!hasOldEvent || (currentTime - startCounterTime >= 180000)) {
        allTimesOk = true;
      }
    }

    // Se todas as formas de onda forem recentes, ou se houver passado 3 minutos, vamos para
    // a próxima parte da geração do relatório
    if (allTimesOk) {

      let scopeLiveList = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "liveList/fisic", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.sort(UtilsInstance.sortBy("address", false, function (a) { return a; })));

      let livelistMap = this.createLivelistMap(scopeLiveList);

      let networkData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "networkData", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let scopeTag = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag);

      let imgURIs = await this.getOscilloscopeImgURIs(oscilloscopeData, livelistMap);

      let ampImgURIs = await this.getDPBarGraphImgURIsAmp(scopeLiveList);
      let minAmpImgURIs = await this.getDPBarGraphImgURIsMinAmp(scopeLiveList);

      let scopeLogData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "log/fisic", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.getNewest200Events(data));

      //-----------------------------------------------------------------------------------------
      //------------------------ Parte de monitoramento --------------------------------
      //-----------------------------------------------------------------------------------------
      let monitorLivelist = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS, { mode: "cors" })
        .then(res => res.json())
        .then(data => data.sort(UtilsInstance.sortBy("address", false, parseInt)));

      let monitorLog = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "log/protocol", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let monitorUptime = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.uptime);

      let monitorDeviceStatistics = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "statistics", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let availability = 0;

      //-----------------------------------------------------------------------------------------
      //------------------------ Parte das configurações de rede --------------------------------
      //-----------------------------------------------------------------------------------------

      // Informaçções da rede ethernet
      let configData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let wifiStatus = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.status);

      // Informações da rede WLAN
      let wifiConfigData = "";

      if (wifiStatus === Constants.CONNECTED_STATUS) {
        wifiConfigData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
          .then(res => res.json())
          .then(data => data);
      }
      else {
        wifiConfigData = {
          "wifiMode": "",
          "hiddenSSID": false,
          "wifiName": "",
          "wifiAddr": "",
          "wifiNetmask": "",
          "wifiGateway": "",
          "wifiDNS": "",
          "wifiPwd": ""
        };
      }

      let ip = window.location.hostname;

      this.setState({
        reportFilename: `Relatório - TS Monitor DeviceNet - Completo (${ip}).pdf`,
        report: <FullReport
          userInput={userInput}
          // Parte do Monitor
          livelist={monitorLivelist}
          log={monitorLog}
          uptime={monitorUptime}
          statistics={monitorDeviceStatistics}
          // Parte do Scope DP 
          scopeLiveList={scopeLiveList}
          livelistMap={livelistMap}
          baudRate={networkData.baudrate}
          masters={networkData.nMasters}
          slaves={networkData.nSlaves}
          tensaoIdle={networkData.tensaoIdle}
          scopeTag={scopeTag}
          imgURIs={imgURIs}
          ampImgURIs={ampImgURIs}
          minAmpImgURIs={minAmpImgURIs}
          scopeLog={scopeLogData}
          // Informações da rede Ethernet
          configData={configData}
          // Informações da rede WLAN
          wifiConfigData={wifiConfigData}
          // Disponibilidade
          availability={availability}
          // Conformidade
          conformity={this.state.conformity}
        />
      });
    }
  }

  // ----------------- Event Handlers -----------------
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleConformityDropdownItemClick = (event, info) => {
    this.setState({ conformity: info.value });
  }

  handleSubmit = async () => {
    let clientImg = "";
    let executorImg = "";
    let startSaveTime = await this.startSaveWaves();
    console.log("Save time: ", startSaveTime);

    if (document.getElementById("client-img").files[0] !== undefined) {
      clientImg = URL.createObjectURL(document.getElementById("client-img").files[0]);
    }

    if (document.getElementById("executor-img").files[0] !== undefined) {
      executorImg = URL.createObjectURL(document.getElementById("executor-img").files[0]);
    }

    this.setState({
      report: "",
      startSaveTime: startSaveTime
    }, () => {
      let userInput = {
        // Client info
        clientProjectName: this.state.clientProjectName,
        clientNetworkName: this.state.clientNetworkName,
        clientLocation: this.state.clientLocation,
        clientCompanyName: this.state.clientCompanyName,
        clientAccountableName: this.state.clientAccountableName,
        clientAddress: this.state.clientAddress,
        clientCity: this.state.clientCity,
        clientTel: this.state.clientTel,
        clientImg: clientImg,
        // Executing company info
        executingCompanyName: this.state.executingCompanyName,
        executingAccountableName: this.state.executingAccountableName,
        executingTel: this.state.executingTel,
        executingEmail: this.state.executingEmail,
        executorImg: executorImg,
        // Notes
        notes: this.state.notes,
        // Conformity
        conformity: this.state.conformity
      };

      // If none of the checkboxes are selected
      if (!this.state.isMonChecked && !this.state.isDPChecked) {
        alert(Strings.SELECT_REPORT_TYPE);
      }
      // If only the monitoring checkbox is selected
      else if (this.state.isMonChecked && !this.state.isDPChecked) {
        this.retrieveMonitoringData(userInput);
      }
      // If only the analyzer DP checkbox is selected
      else if (!this.state.isMonChecked && this.state.isDPChecked) {
        this.retrieveAnalyzerDPData(userInput);
      }
      // If the monitoring and analyzer DP checkboxes are selected
      else if (this.state.isMonChecked && this.state.isDPChecked) {
        this.retrieveAnalyzerDPAndMonitoringData(userInput);
      }
    });

  }

  toggleDPCheckbox = () => {
    this.setState({ isDPChecked: !this.state.isDPChecked });
  }

  toggleMonitoringCheckbox = () => {
    this.setState({ isMonChecked: !this.state.isMonChecked });
  }

  // ----------------- Generate PDF parts utilities ---------------------
  createLivelistMap = (livelistData) => {
    let livelistMap = new Map();

    for (let i = 0; i < livelistData.length; i++) {
      livelistMap.set(livelistData[i].address, livelistData[i]);
    }

    return livelistMap;
  }

  formatTime = (logEntry, timeNow) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getOscilloscopeImgURIs = async (oscilloscopeData, livelistMap) => {
    let imgURIs = [];
    let timeNow = new Date().getTime();
    document.getElementById("chart").style.display = "block";

    // Render the chart
    let chart = new ApexCharts(document.querySelector("#chart"), dnWaveFormOptions);
    chart.render();

    for (let i = 0; i < oscilloscopeData.length; i++) {
      // Every device will have to render its BA and AB waves
      let imgURIObj = { "address": -1, "time": "", "wave": ""};
      let options = {};

      if (livelistMap.get(oscilloscopeData[i].address) === undefined) { continue; }

      let subtitleText = "";


      // Render the wave B - A to get its imgURI
      options = this.getFormatedDPOptions(oscilloscopeData[i].wave, dnWaveFormOptions);

      options = {
        ...options,
        colors: [Constants.BLUE_HEX],
        series: [
          { name: Strings.WAVE_DN, data: this.formatDNWaveTimes(oscilloscopeData[i].wave) }
        ],
        subtitle: {
          text: subtitleText,
          align: "center"
        }
      };

      chart.updateOptions(options, false, false, false);

      imgURIObj.wave = await chart.dataURI();
      imgURIObj.address = await oscilloscopeData[i].address;
      imgURIObj.time = await this.formatTime(oscilloscopeData[i], timeNow);

      // Save both waves URIs
      imgURIs.push(imgURIObj);
    }

    document.getElementById("chart").style.display = "none";

    chart.destroy();

    return imgURIs;
  }

  getFormatedDPOptions = (wave, dpOptions) => {
    let options = {};

    if (wave[wave.length - 1][0] < 1000) {
      // Set the time values to nanosseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_NS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000
      && wave[wave.length - 1][0] < 1000000) {
      // Set the time values to microsseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_US
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }
    else if (wave[wave.length - 1][0] >= 1000000) {
      // Set the time values to millisseconds
      options = {
        ...dpOptions,
        xaxis: {
          type: "numeric",
          title: {
            text: Strings.TIME_MS
          },
          crosshairs: {
            show: "true"
          }
        }
      };
    }

    return options;
  }

  formatDNWaveTimes = (wave) => {
    if (!wave || wave.length === 0) {
      return wave;
    }

    const lastTime = wave[wave.length - 1][0];

    if (lastTime < 1000) {
      return wave.map(point => [...point]);
    }

    if (lastTime >= 1000 && lastTime < 1000000) {
      return wave.map(point => [point[0] / 1000, point[1]]);
    }

    return wave.map(point => [point[0] / 1000000, point[1]]);
  }

  getDPBarGraphImgURIsAmp = async (livelist) => {
    // Make a copy of the live list array
    let devicesToShow = livelist.slice();

    let ampImgURIs = [];
    document.getElementById("barchart").style.display = "block";

    let apexChart = new ApexCharts(document.querySelector("#barchart"), dpBarGraphOptions);
    apexChart.render();

    let numOfPages = Math.ceil(devicesToShow.length / Constants.MAX_DEV_PER_PAGE);

    let ampMap = this.createDPAscAddrAmpPageMap(numOfPages, devicesToShow);
    let imgURIObj = {};

    for (let i = 0; i < numOfPages; i++) {
      let options = {};

      // First get the imgURIs of the amplitudeMedia bar graph
      options = {
        ...dpBarGraphOptions,
        series: [
          { name: Strings.AMPLITUDE, data: ampMap.get(i) }
        ]
      };

      apexChart.updateOptions(options, false, false, false);

      imgURIObj = await apexChart.dataURI();

      ampImgURIs.push(imgURIObj);
    }

    document.getElementById("barchart").style.display = "none";

    apexChart.destroy();

    return ampImgURIs;
  }

  getDPBarGraphImgURIsMinAmp = async (livelist) => {
    // Make a copy of the live list array
    let devicesToShow = livelist.slice();

    let minAmpImgURIs = [];
    document.getElementById("barchart").style.display = "block";

    let apexChart = new ApexCharts(document.querySelector("#barchart"), dpBarGraphOptions);
    apexChart.render();

    let numOfPages = Math.ceil(devicesToShow.length / Constants.MAX_DEV_PER_PAGE);

    let minAmpMap = this.createDPAscAddrMinAmpPageMap(numOfPages, devicesToShow);
    let imgURIObj = {};

    for (let i = 0; i < numOfPages; i++) {
      let options = {};

      // Then get the imgURIs of the min amplitudeMedia bar graph
      options = {
        ...dpBarGraphOptions,
        series: [
          { name: Strings.MIN_AMPLITUDE, data: minAmpMap.get(i) }
        ]
      };

      apexChart.updateOptions(options, false, false, false);

      imgURIObj = await apexChart.dataURI();

      minAmpImgURIs.push(imgURIObj);
    }

    document.getElementById("barchart").style.display = "none";

    apexChart.destroy();

    return minAmpImgURIs;
  }

  createDPAscAddrAmpPageMap = (numOfPages, livelist) => {
    let ascAddrAmpMap = new Map();

    let ascAddrSortedDevices = livelist.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < numOfPages; i++) {
      let devicesSlice = [];

      if (i === (numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitudeMedia)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrAmpMap.set(i, ampPageSeries);
    }

    return ascAddrAmpMap;
  }

  createDPAscAddrMinAmpPageMap = (numOfPages, livelist) => {
    let ascAddrMinAmpMap = new Map();

    let ascAddrSortedDevices = livelist.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < numOfPages; i++) {
      let devicesSlice = [];

      if (i === (numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitudeMinima)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMinAmpMap.set(i, minAmpPageSeries);
    }

    return ascAddrMinAmpMap;
  }

  getNewest200Events = (log) => {
    let newest200Events = [];

    if (log.length > Constants.MAX_NUM_OF_LOG_EVENTS) {
      for (let i = 0; i < Constants.MAX_NUM_OF_LOG_EVENTS; i++) {
        newest200Events.push(log[i]);
      }
    }
    else {
      for (let i = 0; i < log.length; i++) {
        newest200Events.push(log[i]);
      }
    }

    return newest200Events;
  }

  // Função que faz um POST para avisar o backend que ele deverá começar a salvar as formas de 
  // onda na base de dados para que elas sejam utilizadas na hora de gerar o relatório
  startSaveWaves = async () => {
    let startSaveTime = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "startSaveWaves_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: { "update": true }
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        console.log("startSaveWaves_POST funcionou");
        return Date.now();
      })
      .catch(() => {
        console.log("startSaveWaves_POST não funcionou");
        return Date.now();
      });

    return startSaveTime;
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
  }

  render() {
    const {
      clientProjectName,
      clientNetworkName,
      clientLocation,
      clientCompanyName,
      clientAccountableName,
      clientAddress,
      clientCity,
      clientTel,
      executingCompanyName,
      executingAccountableName,
      executingTel,
      executingEmail,
      notes
    } = this.state;

    return (
      <div style={divStyle}>

        <Grid columns={2} doubling stretched>
          <Grid.Column>
            <Segment>

              <Divider horizontal>{Strings.CLIENT_INFO}</Divider>
              <Form>
                <Form.Input label={Strings.FORM_PROJECT_NAME} name='clientProjectName' value={clientProjectName} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_NETWORK_NAME} name='clientNetworkName' value={clientNetworkName} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_LOCATION} name='clientLocation' value={clientLocation} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_COMPANY_NAME} name='clientCompanyName' value={clientCompanyName} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_ACCOUNTABLE_NAME} name='clientAccountableName' value={clientAccountableName} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_ADDRESS} name='clientAddress' value={clientAddress} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_CITY} name='clientCity' value={clientCity} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_PHONE} name='clientTel' value={clientTel} onChange={this.handleChange} />
                <Form.Input id="client-img" label={Strings.CLIENT_LOGO} type="file" accept=".png,.jpg,.jpeg" />
              </Form>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment>

              <Divider horizontal>{Strings.EXECUTING_COMPANY_INFO}</Divider>

              <Form>
                <Form.Input label={Strings.FORM_COMPANY_NAME} name='executingCompanyName' value={executingCompanyName} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_ACCOUNTABLE_NAME} name='executingAccountableName' value={executingAccountableName} onChange={this.handleChange} />
                <Form.Input label={Strings.FORM_PHONE} name='executingTel' value={executingTel} onChange={this.handleChange} />
                <Form.Input label={Strings.EMAIL} name='executingEmail' value={executingEmail} onChange={this.handleChange} />
                <Form.Input id="executor-img" label={Strings.EXECUTING_COMPANY_LOGO} type="file" accept=".png,.jpg,.jpeg" />
              </Form>
            </Segment>

            <Grid columns={2} doubling>
              <Grid.Column verticalAlign="middle">
                <Segment>
                  <Divider horizontal>{Strings.CONFORMITY}</Divider>
                  <Dropdown
                    fluid
                    selection
                    placeholder={Strings.DROPDOWN_PLACEHOLDER}
                    options={dropdownOptions}
                    onChange={this.handleConformityDropdownItemClick} />
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment>
                  <Divider horizontal>{Strings.REPORT_TYPE}</Divider>

                  <Form>
                    <Form.Field style={{ marginBottom: "-1vh", textAlign: "center" }}>
                      <Checkbox
                        label={Strings.PHYS_MEDIUM}
                        onChange={this.toggleDPCheckbox}
                        checked={this.state.isDPChecked} />
                    </Form.Field>
                    <Form.Field style={{ marginBottom: "-1vh", marginLeft: "-19pt" }}>
                      <Checkbox
                        label={Strings.MONITORING}
                        onChange={this.toggleMonitoringCheckbox}
                        checked={this.state.isMonChecked} />
                    </Form.Field>

                  </Form>

                </Segment>

              </Grid.Column>
            </Grid>

            <Segment>
              <Divider horizontal>{Strings.ANNOTATIONS}</Divider>
              <Form>
                <Form.Input type="text" name='notes' value={notes} onChange={this.handleChange} />
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>

        <Button
          style={buttonStyle}
          color="teal"
          onClick={this.handleSubmit}>
          {Strings.GENERATE_REPORT}
        </Button>

        <PDFDownloadLink
          style={pdfLinkStyle}
          document={this.state.report}
          fileName={this.state.reportFilename}>
          {({ loading }) => {
            if (loading) {
              return Strings.FINALIZING;
            }
            else {
              if (this.state.isGenerateReportDimmerActive) {
                this.setGeneratingDimmerState(false);
              }
              return Strings.SAVE_REPORT;
            }
          }}
        </PDFDownloadLink>

        <div id="chart" style={chartsStyle}></div>
        <div id="barchart" style={chartsStyle}></div>

        <Dimmer page active={this.state.isGenerateReportDimmerActive}>
          <Loader size="huge" indeterminate>
            {this.state.loaderText1}<br />
            {this.state.loaderText2}
          </Loader>
        </Dimmer>

      </div>
    );
  }
}

const chartsStyle = {
  width: "1026px",
  height: "580px",
  display: "none",
  visibility: "hidden"
};

const divStyle = {
  margin: "2vh 2vw",
  textAlign: "center"
};

const buttonStyle = {
  margin: "2vh auto"
};

const pdfLinkStyle = {
  marginLeft: "2vw"
};

export default withRouter(Report);
